import axios from "axios";
import Apiconfigs from "../ApiConfig";
import { getContract } from "src/utils";
import moment from "moment";
import { toast } from "react-hot-toast";

// Helper function to get headers with proper Authorization
const getAuthHeaders = () => {
  const token = window.localStorage.getItem("token");
  const headers = {};

  if (token && token !== "null" && token !== "undefined") {
    headers.Authorization = `Bearer ${token}`;
    headers.token = token; // backend verifies req.headers.token
  }

  return headers;
};

export const getPerticularData = async (endPoint) => {
  try {
    const res = await axios({
      method: "GET",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
    });
    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);

    return;
  }
};

export const postAPIHandle = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "POST",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      data: data,
    });

    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);
    
    return;
  }
};
export const postAPIHandleConnectWallet = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "POST",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      data: data,
    });

    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);
    if (error.response) {
      toast.error(error.response.data.responseMessage);
    } else {
      toast.error(error.message);
    }
    return;
  }
};
export const postAPIHandler = async ({ endPoint, dataToSend, paramsData }) => {
  try {
    return await axios({
      method: "POST",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      data: dataToSend ? dataToSend : null,
      params: paramsData ? paramsData : null,
    });
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

// Guard helper: prevent buy if kyc not completed
export const requireKycOrThrow = (userData) => {
  const status = userData?.kycStatus;
  if (!status || status === 'pending' || status === 'rejected') {
    throw new Error('KYC required to perform this action. Please complete verification.');
  }
};
export const postAPIHandleWithId = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "POST",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      data: data,
    });

    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);
    return;
  }
};

export const postAPIHandleWithToast = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "POST",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      data: data,
    });
    if (res.data.responseCode === 200) {
      toast.success(res.data.responseMessage);
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    toast.error(error.response.data.responseMessage);
    return;
  }
};

export const getAPIHandle = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "GET",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
    });
    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);
    return;
  }
};

export const putAPIHandle = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "PUT",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      data: data,
    });
    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);
    return;
  }
};

export const getPerticularIdByPath = async (endPoint, _id) => {
  try {
    const res = await axios({
      method: "GET",
      url: `${Apiconfigs[endPoint]}/${_id}`,
      headers: getAuthHeaders(),
    });
    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);

    return;
  }
};

export const getPerticularIdByQuery = async (endPoint, _id) => {
  try {
    const res = await axios({
      method: "GET",
      url: Apiconfigs[endPoint],
      // headers: {
      //   token: window.localStorage.getItem("token"),
      // },
      params: _id,
    });
    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);

    return;
  }
};
export const getPerticularWithToken = async (endPoint, dataSend) => {
  try {
    const res = await axios({
      method: "GET",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      params: dataSend,
    });
    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);

    return;
  }
};

export const getPerticularwithtokenIdByQuery = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "GET",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      params: data,
    });
    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);

    return;
  }
};

export const likeDislike = async (endPoint, _id) => {
  try {
    const res = await axios({
      method: "GET",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      params: _id,
    });
    if (res.data.responseCode === 200) {
      toast.success(res.data.responseMessage);
      return res;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);

    return;
  }
};

export const uploadImageHandler = async (endPoint, image) => {
  const formDataImages = new FormData();
  formDataImages.append("image", image);

  try {
    const res = await axios({
      method: "POST",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      data: formDataImages,
    });

    if (res.data.responseCode === 200) {
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);
  }
};

export const putAPIHandleWithToast = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "PUT",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      data: data,
    });
    if (res.data.responseCode === 200) {
      toast.success(res.data.responseMessage);
      return res.data.result;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);
    return;
  }
};
export const putAPIHandleInQueryWithToast = async (endPoint, data) => {
  try {
    const res = await axios({
      method: "PUT",
      url: Apiconfigs[endPoint],
      headers: getAuthHeaders(),
      params: data,
    });
    console.log("res=====", res);
    if (res.data.responseCode === 200) {
      toast.success(res.data.responseMessage);
      return res.data;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);
    return;
  }
};
